package com.siriusxm.pia

import com.siriusxm.cmc.CMCViewer
import com.siriusxm.cmc.utils.IdToken

/**
 * Encapsulates the application viewer.
 */
public class Viewer(
    private val token: IdToken?,
    public val accessToken: String?,
    public val idToken: String?
) {
    public val id: String? get() = token?.sub

    public val contentEditor: Boolean by lazy {
        isInGroup(UserGroup.AggregatorAdmin) || isInGroup(UserGroup.AggregatorContentAdmin)
    }

    public val operationsUser: Boolean by lazy {
        isInGroup(UserGroup.AggregatorAdmin) || isInGroup(UserGroup.AggregatorOperations)
    }

    public val transcriptionAdmin: Boolean by lazy {
        isInGroup(UserGroup.AggregatorAdmin) || isInGroup(UserGroup.AggregatorTranscriptions)
    }

    public val aggregatorAdmin: Boolean by lazy {
        isInGroup(UserGroup.AggregatorAdmin)
    }

    /**
     * The list of groups of this viewer.
     */
    public val groups: List<String> get() = token?.cognitoGroups ?: emptyList()

    /**
     * Is the viewer a part of a given group
     */
    public fun isInGroup(group: UserGroup): Boolean {
        return token?.cognitoGroups?.contains(group.id) ?: false
    }

    /**
     * Is the viewer a part of a given group
     */
    public fun isInGroup(groupId: String): Boolean {
        return token?.cognitoGroups?.contains(groupId) ?: false
    }

    /**
     * Get the viewer's email address.
     */
    public val email: String? get() = token?.email
}

public enum class UserGroup(public val id: String, public val title: String, public val iconName: String?) {
    AggregatorAdmin("app-uni-content-aggregator-admin", "Admin", "admin_panel_settings"),
    AggregatorContentAdmin("app-uni-content-contentadmin", "Content Admin", "save_as"),
    AggregatorOperations("app-uni-content-operations", "Operations", "edit_road"),
    AggregatorTranscriptions("app-uni-content-transcriptions", "Transcription", "transcribe")

}

public fun CMCViewer.isInAnyGroup(vararg groups: UserGroup): Boolean {
    val groupIds = groups.map { it.id }
    return this.groups.intersect(groupIds).isNotEmpty()
}

public val CMCViewer.contentEditor: Boolean
    get() {
        return isInAnyGroup(UserGroup.AggregatorAdmin, UserGroup.AggregatorContentAdmin)
    }

public val CMCViewer.operationsUser: Boolean
    get() {
        return isInAnyGroup(UserGroup.AggregatorAdmin, UserGroup.AggregatorOperations)
    }

public val CMCViewer.transcriptionAdmin: Boolean
    get() {
        return isInAnyGroup(UserGroup.AggregatorAdmin, UserGroup.AggregatorTranscriptions)
    }

public val CMCViewer.aggregatorAdmin: Boolean
    get() {
        return isInAnyGroup(UserGroup.AggregatorAdmin)
    }